import { Switch } from './switch';

export class PrevalenceSwitch extends Switch {
    showPrevalence = () => {
        return !this.isChecked ? false : true;
    };
}
